import axiosHelper from './helpers/axiosHelper';
import UserRoleModel from './models/UserRoleModel';

const userRolesModule = {
	state() {
		return {			
			roles: null
		}
	},
	actions: {
		async loadRolesAsync(ctx: any) {
			try {
				const refreshTokenHttpClient = axiosHelper.createInstance();
				const response = await refreshTokenHttpClient.get('/api/users/roles');
				if (!response?.data?.length) {
					ctx.commit('addUserRoles', []);
				}
				const roles = response.data.map((r: any) => new UserRoleModel(r));
				ctx.commit('addUserRoles', roles);
			} catch (e) {
				console.error('Unable to get user roles', e);
			}
		}
	},
	mutations: {		
		addUserRoles(state: any, payload: Array<any>) {
			state.roles = payload;
		}
	},
	getters: {
		/* list of all existing roles */
		userRoles(state: any) : Array<UserRoleModel> {
			return state.roles;
		},
	}
};

export default userRolesModule;